var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-component',{attrs:{"toggleDrawer":() => (_vm.drawer = !_vm.drawer)}}),_c('v-sheet',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }